import { render, staticRenderFns } from "./LeftInfo3.vue?vue&type=template&id=8bf31e8e&scoped=true"
import script from "./LeftInfo3.vue?vue&type=script&lang=js"
export * from "./LeftInfo3.vue?vue&type=script&lang=js"
import style0 from "./LeftInfo3.vue?vue&type=style&index=0&id=8bf31e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf31e8e",
  null
  
)

export default component.exports